import { FC, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { DeleteCollectionsModal } from "@/components/modal/delete-collections";
import { CollectionsListPageList } from "@/pages/collections/components/collections-list-page-list";
import { useEffectOnMount } from "@/domains/react/useEffectOnMount";
import { MDSFadeBottom } from "@/mds";
import { ShareSheetModal } from "@/components/modal/share-sheet/share-sheet-modal";
import { CollectionsListPageHeader } from "@/pages/collections/components/collections-list-page-header";
import { MDSPanelContainer } from "@/mds";
import { TrackedEvent } from "@/domains/metrics";
import { trackEvent } from "@/domains/metrics";
import { useTabPageStore } from "@/components/layout/components/tab-bar/use-tab-page-store";

interface CollectionsListPageProps {}

export const CollectionsListPage: FC<CollectionsListPageProps> = observer(() => {
  const page = useTabPageStore("collectionsListPage");

  useEffectOnMount(() => {
    page.resetState();
  });

  /**
   * Track views of the collections list page.
   */
  useEffect(() => {
    trackEvent(TrackedEvent.CollectionsView, {
      lens: page.lens,
      sort_by: page.sortBy,
    });
  }, [page.lens, page.sortBy]);

  return (
    <>
      <ShareSheetModal store={page.shareSheetModal} />
      <DeleteCollectionsModal state={page.deleteCollectionModal} />
      <CollectionsListPageHeader />
      <MDSPanelContainer>
        <CollectionsListPageList />
        <MDSFadeBottom />
      </MDSPanelContainer>
    </>
  );
});
